import { stringify } from 'qs'

import { useCustomSWRInfinite } from 'utils/hooks/fetchers'

export const useInfiniteArticles = (props, swrOptions) => {
  const getArticlesKey = (opts) => (pageIndex, previousPageData) => {
    const propsObject = typeof opts === 'function' ? opts() : opts
    if (propsObject === null) {
      return null
    }
    if (previousPageData && !previousPageData.length) {
      return null
    }
    const params = {
      ...propsObject,
      skip: pageIndex * (propsObject.limit || 20),
      limit: propsObject.limit || 20,
    }
    return `/articles?${stringify(params)}`
  }
  const { data, ...rest } = useCustomSWRInfinite(
    getArticlesKey(props),
    swrOptions
  )
  // data會無預期出現數字，不確定為什麼，
  // 先避免直接回傳錯誤的資料類型
  return { data: typeof data === 'number' ? [] : data, ...rest }
}
